<template>
  <div class="profile container">
    <LayoutSection>
      <div class="previousBtn">
        <PreviousPageBtn label-code="myAccount" />
      </div>
      <el-row class="d-flex align-items-center">
        <el-col class="p-20 sales-image sales-img-sec" :xs="24" :sm="12" :md="12">
          <div class="bg-accent-light text-center p-20 mt-15">
            <img :src="profileImage" class="account-image" />
          </div>
        </el-col>
        <el-col
          class="p-20"
          :xs="24"
          :sm="12"
          :md="12"
        >
          <h1 class="text-left d-flex align-items-center">
            {{ profileTitle }}
          </h1>
        </el-col>
      </el-row>
      <el-row class="mt-60">
        <LayoutSection size="o25v50">
          <el-col>
            <el-link
              v-if="userEditDetailsBtn"
              class="logout-btn mt-10"
              :underline="true"
              @click="setuserDetails()"
            >
              {{ $t("users.account.editBtn") }}
            </el-link>
            <h4 class="profile-page text-left mt-10">
              {{ $t("users.account.personnalInfosTitle") }}
            </h4>
            <div class="personnal-infos-box mt-18 text-left" v-if="showCustomerDetills">
              <span>{{ customerDatails.contact.firstName }} {{ customerDatails.contact.lastName }}</span
              ><br />
              <span>{{ customerDatails.contact.email }}</span>
              <span><br />{{ customerDatails.contact.phone }}</span>
            </div>
            <div class="user-details-form" v-if="showDetailform">
              <el-form
                ref="userDetailsUpdate"
                :model="userDetail"
                :rules="userRules"
              >
                <div class="mb-1">
                  <el-row :gutter="10">
                    <el-col :xs="12" :sm="12" :md="6">
                      <el-form-item prop="firstName">
                        <el-input
                          class="userDetail-input"
                          v-model="userDetail.firstName"
                          :placeholder="$t('users.label.firstName')"
                        />
                      </el-form-item>
                    </el-col>
                    <el-col :xs="12" :md="6" :sm="12">
                      <el-form-item prop="lastName">
                        <el-input
                          class="userDetail-input"
                          v-model="userDetail.lastName"
                          :placeholder="$t('users.label.lastName')"
                        />
                      </el-form-item>
                    </el-col>
                  </el-row>
                </div>
                <el-row>
                  <el-col :xs="24" :md="12" :sm="24">
                    <el-form-item prop="email">
                      <el-input
                        class="userDetail-input"
                        v-model="userDetail.email"
                        prop="email"
                        :placeholder="$t('users.label.email')"
                      />
                    </el-form-item>
                  </el-col>
                </el-row>
                <el-row>
                  <el-col :xs="24" :md="12" :sm="24">
                    <el-form-item prop="phone">
                      <el-input
                        class="userDetail-input"
                        v-model="userDetail.phone"
                        prop="email"
                        :placeholder="$t('users.label.phone')"
                      />
                    </el-form-item>
                  </el-col>
                </el-row>
                <el-row class="text-left mt-15">
                  <el-button
                    type="primary"
                    native-type="submit"
                    class="ctaSubmit"
                    @click="updateUserDetails"
                  >
                    {{ $t("users.label.record") }}
                  </el-button>
                </el-row>
              </el-form>
            </div>
            <el-divider class="mt-60" />
          </el-col>
          <el-col>
            <el-link
              v-if="passwordDetails"
              class="logout-btn"
              :underline="true"
              @click="(passwordform = true), (passwordDetails = false)"
            >
              {{ $t("users.account.editBtn") }}
            </el-link>
            <h4 class="profile-page text-left">
              {{ $t("users.account.password") }}
            </h4>
            <div
              class="personnal-infos-box mt-18 text-left"
              v-if="passwordDetails"
            >
              <span>xxxxxxxxxx</span>
            </div>
            <div v-if="passwordform">
              <PasswordUpdateComponent
                :cta-submit-text="$t('users.login.label.login')"
                @emit-password-update="emitTogglePasswordUpdate"
              />
            </div>
            <el-divider class="mt-60" />
          </el-col>
          <el-col>
            <el-link
              class="logout-btn"
              :underline="true"
              :v-bind="deliveryAddressDetails"
              @click="
                showDetailAddressform = true;
                deliveryAddressDetails = false;
              "
            >
              {{ $t("users.account.editBtn") }}
            </el-link>
            <h4 class="profile-page text-left">
              {{ $t("users.account.shippingAndBillingAddresses") }}
            </h4>
            <div
              class="personnal-infos-box mt-18 text-left"
              v-if="deliveryAddressDetails"
            >
            <AddressTile v-if="billingAddress" :billingAddress="billingAddress" :shippingAddress="shippingAddress" />
            <!-- <AddressTile v-if="shippingAddress"  titleClass="mt-6"/> -->
            </div>
            <DeliveryAddressComponent
              v-if="showDetailAddressform"
              :shippingAddress="setShippingAddress"
              :billingAddress="setBillingAddress"
              :countries="Countries"
              :cta-submit-text="$t('users.login.label.login')"
              @emit-address-update="emitToggleAddressUpdate"
            />
            <el-divider class="mt-60" />
          </el-col>
          <el-col>
            <el-link
              class="logout-btn"
              :underline="true"
              @click="findBranch = true"
            >
              {{ $t("users.account.editBtn") }}
            </el-link>
            <h4 class="profile-page text-left">
              {{ $t("users.account.branchPickup") }}
            </h4>

            <div class="text-left" style="line-height: 1.6;" v-if="selectedBranch">
              <br>
              <span>{{selectedBranch.addressLine}}</span><br />
              <span>{{selectedBranch.label}}</span><br />
              <span>{{selectedBranch.number}}</span><br />
              <span>{{selectedBranch.phone}}</span><br />
            </div>
            <el-divider class="mt-60" />
          </el-col>
          <!-- Branch pickup model start -->
          <div class="branchPickup">
            <el-dialog :visible.sync="findBranch" width="30%">
              <h3 class="text-left title">
                {{ $t("users.branchPickup.title") }}
              </h3>
              <h6 class="text-left mt-15 subtitle">
                {{ $t("users.branchPickup.subTitle") }}
              </h6>
              <el-select
              v-model="selectedBranch"
              filterable
              remote
              reserve-keyword
              :placeholder="saqPlaceholder"
              :remote-method="remoteMethod"
              :no-match-text="noBranchFound"
              :no-data-text="noBranchFound"
              :class="'saq-branches'"
              @visible-change="handleDropdownVisibility"
              >
              <el-option
                v-for="item in saqBranchesOptions"
                :key="item.value"
                :label="item.addressLine + ', ' + item.label"
                :value="item">
              </el-option>
            </el-select>
              <span slot="footer" class="dialog-footer">
                <el-button @click="findBranch = false">{{
                  $t("users.branchPickup.cancel")
                }}</el-button>
                <el-button type="primary" @click="findBranch  = false">{{
                  $t("users.branchPickup.submit")
                }}</el-button>
              </span>
            </el-dialog>
          </div>
          <!-- Branch pickup model end -->
        </LayoutSection>
      </el-row>
    </LayoutSection>
  </div>
</template>
<script>
import { mapState, mapActions } from "vuex";

import { get, find } from "@/utils/lodash";

import Store from "@/store";

import LayoutSection from "@/components/layout/layout-section.vue";
import PreviousPageBtn from "@/components/previous-page-btn.vue";
import AddressTile from "@/components/address-tile.vue";
import DeliveryAddressComponent from "./components/delivery-address-form.vue";
import PasswordUpdateComponent from "./components/password-update.vue";
import userApi from "@/api/user";
import countryApi from "@/api/country";
import checkoutApi from "@/api/checkout";
export default {
  components: {
    LayoutSection,
    PreviousPageBtn,
    AddressTile,
    DeliveryAddressComponent,
    PasswordUpdateComponent,
  },
  props: {},
  data() {
    return {
      showDetailform: false,
      userDetails: true,
      userDetail: {
        firstName: null,
        lastName: null,
        email: null,
        phone: null,
      },
      userRules: {
        firstName: [
          {
            required: true,
            message: this.$i18n.t("checkout.form.firstName"),
          },
        ],
        lastName: [
          {
            required: true,
            message: this.$i18n.t("checkout.form.lastName"),
          },
        ],
        email: [
          {
            required: true,
            message: this.$i18n.t("checkout.form.email"),
          },
        ],
        phone: [
          {
            required: true,
            message: "Votre téléphone est obligatoire",
          },
        ],
      },
      passwordform: false,
      passwordDetails: true,
      showDetailAddressform: false,
      deliveryAddressDetails: true,
      findBranch: false,
      branchPickup: "province",
      branchPickupoptions: [
        {
          value: "province",
          label: "Province",
        },
        {
          value: "quebec",
          label: "Québec",
        },
        {
          value: "Ontario",
          label: "Ontario",
        },
      ],
      Countries: [],
      userEditDetailsBtn: true,
      showCustomerDetills: false,
      customerDatails: {},
      saqBranches: [],
      list: [],
      saqBranchesOptions: [],
      selectedBranch: null,
      noBranchFound: this.$i18n.t("checkout.noBranchFound"),
    };
  },
  computed: {
    saqPlaceholder() {
      return this.$i18n.t("checkout.produitsdeagenceText");
    },
    billingAddress() {
      const addresses = get(this.customerDatails, "contact.addresses");

      if (addresses == null) return null;

      return find(addresses, (addr) => addr.type.code === "BILLING");
    },
    shippingAddress() {
      const addresses = get(this.customerDatails, "contact.addresses");

      if (addresses == null) return null;

      return find(addresses, (addr) => addr.type.code === "SHIPPING");
    },
    profileTitle() {
      return this.$i18n.t("users.account.profileTitle").toUpperCase();
    },
    profileImage() {
      /* eslint-disable global-require */
      return require("@/assets/images/account/profile.png");
    },
    ...mapState("user", ["user"]),
    setBillingAddress() {
      const addresses = get(this.user, "billingAddress");

      if (addresses == null) {
        return {
          street: null,
          postalCode: null,
          state: {
            id: null,
            name: null,
          },
          country: {
            id: null,
          },  
        };
      }
      return addresses;
    },
    setShippingAddress() {
      const addresses = get(this.user, "shippingAddress");
      if (addresses == null) {
        return {
          street: null,
          postalCode: null,
          state: {
            id: null,
            name: null,
          },
          country: {
            id: null,
          },
        };
      }
      return addresses;
    },
  },
  async created() {
    await this.fetchCountries();
    await this.fetchCustomer();
    await this.fetchSaqBranches();
  },
  methods: {
    ...mapActions("user", ["updateUser"]),
    async fetchSaqBranches() {
      await checkoutApi.fetchSaqBranches().then((result) => {
        this.saqBranches = result;
      });
      this.list = this.saqBranches.map(item => {
        return { value: item.id, label: item.city, number:item.number, phone:item.phone, addressLine:item.addressLine };
      });
    },
    remoteMethod(query) {
      this.loading = false;
          this.saqBranchesOptions = this.list.filter(item => {
            const cityMatch = item.label.toLowerCase().includes(query.toLowerCase());
            const addressMatch = item.addressLine.toLowerCase().includes(query.toLowerCase());
            return addressMatch || cityMatch; // Match either city or address
          })

      .sort((a, b) => {
      // Extract numbers at the start of the address line
      const numberA = parseInt(a.addressLine);
      const numberB = parseInt(b.addressLine);

      // Fallback to label if number extraction fails
      if (isNaN(numberA) || isNaN(numberB)) {
        return a.label.localeCompare(b.label);
      }

      return numberA - numberB;
    });
    },
    handleDropdownVisibility(visible) {
    if (visible && this.saqBranchesOptions.length === 0) {
      this.remoteMethod(''); // call with empty string to load all data initially
    }
  },
    resetFields() {
      this.$refs.userDetailsUpdate.resetFields();
    },
    fetchCountries() {
      Promise.all([countryApi.fetchCountries()]).then((result) => {
        this.Countries = result[0];
      });
    },
    fetchCustomer(){
      const userId = this.user && this.user.customer && this.user.customer.id || this.user && this.user.id
      Promise.all([userApi.getCustomerDetails(userId)]).then((result) => {
        this.showCustomerDetills = true;
        this.customerDatails = result[0];
      });
    },
    setuserDetails() {
      this.showDetailform = true;
      this.userDetails = false;
      this.userDetail = this.customerDatails.contact;
      this.userEditDetailsBtn = false;
    },
    updateUserDetails(e) {
      e.preventDefault();
      const vm = this;
      this.$refs.userDetailsUpdate.validate().then((valid) => {
        if (valid) {
          const userId = this.user && this.user.customer && this.user.customer.id
          userApi
            .updateCustomerDetails(userId, {
              firstName: vm.userDetail.firstName,
              lastName: vm.userDetail.lastName,
              email: vm.userDetail.email,
              phone: vm.userDetail.phone,
            })
            .then((data) => {
              if (data) {
                this.userEditDetailsBtn = true;
                this.showDetailform = false;
              } else {
                vm.$emit("error", "cannot authenticate user");
              }
            })
            .catch((error) => {
              vm.$emit("error", error);
            });
        }
      });
    },
    emitTogglePasswordUpdate() {
      this.passwordform = false;
      this.passwordDetails = true;
    },
    emitToggleAddressUpdate() {
      this.showDetailAddressform = false;
      this.deliveryAddressDetails = true;
      this.updateUser();
    },
    updateUser() {
      userApi.findById(JSON.parse(localStorage.user).user.id).then((user) => {
        Store.dispatch("user/setUserProfile", user);
      });
      this.fetchCustomer();
    },
  },
};
</script>

<style lang="scss">
@import "@/assets/variables.scss";
.previousBtn {
  font-family: "Futura Std ", "Futura Std", sans-serif;
  font-weight: 500;
  color: $color-primary;
  text-align: left;
  line-height: normal;
  letter-spacing: 1.25px;
  font-size: 16px !important;
}
.branchPickup {
  .el-dialog__body {
    padding-top: 0px;
    text-align: left;
  }
  .el-select {
    border: 1px solid #dcdfe6;
    div input {
      text-align: left !important;
    }
  }
  .title {
    color: #000;
    word-break: break-word;
  }
  .subtitle {
    font-size: 12px;
    font-weight: 500;
    word-break: break-word;
  }
  .el-button {
    font-size: 14px;
  }
}

.account-image {
  width: 164px;
  height: 251px;
}

.account-tile-desscription {
  margin-top: 10px;
}

.account-tile-title {
  font-size: 18px;
  font-weight: bold;
}

.logout-btn {
  position: relative;
  font-weight: 500;
  float: right;
  font-size: 16px;
  color: #a31c25 !important;
}
.account-title {
  color: #000;
}
.read-more {
  color: #a31c25 !important;
  font-size: 16px;
}
#product-cards-list-similar {
  width: 100%;
}
// #product-cards-list-similar .carousel__width {
//   width: 95%;
// }
.suggestions {
  font-weight: 700;
  color: #000;
  font-size: 25px;
}
.subscription {
  opacity: 1;
}
.text-left.d-flex{
  height: 100%;
}
.sales-image {
  padding-left: 0 !important;
}
.d-flex.align-items-center.el-row {
  flex-wrap: wrap;
}
.delivery-info-profile {

}
</style>
